import React from 'react';
import style from './StripeHandler.module.css';

import Lottie from 'lottie-react';
import premium_animation from '../../lottieAnimations/premium_animation.json';
import warning_animation from '../../lottieAnimations/warning_animation.json';
import check_animation from '../../lottieAnimations/checkmark.json';
import icons from '../../icons';

// import SwiperCore, { EffectFlip, Autoplay  } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import Banner from '../Banner/Banner';


// SwiperCore.use([ EffectFlip, Autoplay ]);

const StripeHandler = props => {
    if (!props.status)
        return <>
            <Banner />
            <main className={ style.main }>
                <Lottie 
                    autoplay={ true }
                    loop={ false }
                    animationData={ warning_animation }
                    rendererSettings={{
                        preserveAspectRatio: "xMidYMid slice"
                    }}
                    height={ 300 }
                    width={ 300 }
                />
                <h3 className={ style.sectionHeader } style={{ textAlign: "center", marginTop: "-.5rem" }}>Qualcosa non ha funzionato</h3>
                <div className={ style.orangeBtn } onClick={ () => props.setPage({ page: "home" }) }>
                    <img style={{ marginLeft: "1rem" }} alt="" src={ icons.home_icon } />
                    <h3>VAI ALLA HOME</h3>
                </div>
            </main>
        </>;

    switch (props.action) {
        case "create":
            return <>
                <Banner />
                <main className={ style.main }>
                    <Lottie 
                        autoplay={ true }
                        loop={ true }
                        animationData={ premium_animation }
                        rendererSettings={{
                            preserveAspectRatio: "xMidYMid slice"
                        }}
                        height={ 300 }
                        width={ 300 }
                    />
                    <h3 className={ style.sectionHeader } style={{ textAlign: "center", marginTop: "-.5rem" }}>Grazie per essere passato a premium!</h3>
                    <Swiper direction="horizontal" effect={ "flip" } loop={ true } autoplay={{ delay: 3000 }} speed={ 500 }>
                        <SwiperSlide>
                            <div className={ style.premiumContainer } style={{ background: "rgb(83, 82, 82)" }}>
                                <h3>SchoolDiary <span style={{ color: "var(--orange)" }}>Premium</span></h3>
                                <h4 style={{
                                    marginLeft: "1rem",
                                    fontSize: "1.5rem",
                                    marginTop: "-.5rem",
                                    marginBottom: "1rem",
                                }}>€2,99 <span style={{ fontSize: ".7rem" }}>al mese</span></h4>
                                <hr className={ style.separator }></hr>
                                {/* <div className={ style.premiumListItem } style={{ marginTop: "0" }}>
                                    <img src={ icons.check_icon }></img>
                                    <h5>Nessuna pubblicità</h5>
                                </div> */}
                                <div className={ style.premiumListItem }>
                                    <img src={ icons.check_icon }></img>
                                    <h5>Badge utente premium</h5>
                                </div>
                                <div className={ style.premiumListItem }>
                                    <img src={ icons.check_icon }></img>
                                    <h5>Limite dimensione allegati: <span style={{ color: "var(--orange)" }}>20MB</span></h5>
                                </div>
                                <div className={ style.premiumListItem }>
                                    <img src={ icons.check_icon }></img>
                                    <h5>Limite numero allegati: <span style={{ color: "var(--orange)" }}>10</span></h5>
                                </div>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className={ style.premiumContainer }>
                                <h3>SchoolDiary <span style={{ color: "var(--orange)" }}>Free</span></h3>
                                <h4 style={{
                                    marginLeft: "1rem",
                                    fontSize: "1.5rem",
                                    marginTop: "-.5rem",
                                    marginBottom: "1rem",
                                }}>€0,00 <span style={{ fontSize: ".7rem" }}>al mese</span></h4>
                                <hr className={ style.separator }></hr>
                                {/* <div className={ [style.premiumListItem, style.disabled].join(" ") } style={{ marginTop: "0" }}>
                                    <img src={ icons.check_icon_disabled }></img>
                                    <h5>Nessuna pubblicità</h5>
                                </div> */}
                                <div className={ [style.premiumListItem, style.disabled].join(" ") }>
                                    <img src={ icons.check_icon_disabled }></img>
                                    <h5>Badge utente premium</h5>
                                </div>
                                <div className={ style.premiumListItem }>
                                    <img src={ icons.check_icon }></img>
                                    <h5>Limite dimensione allegati: 3MB</h5>
                                </div>
                                <div className={ style.premiumListItem }>
                                    <img src={ icons.check_icon }></img>
                                    <h5>Limite numero allegati: 3</h5>
                                </div>
                            </div>
                        </SwiperSlide>
                    </Swiper>
                    <div className={ style.orangeBtn } onClick={ () => props.setPage({ page: "home" }) }>
                        <img style={{ marginLeft: "1rem" }} alt="" src={ icons.home_icon } />
                        <h3>VAI ALLA HOME</h3>
                    </div>
                </main>
            </>;

        case "cancel":
            return <>
                <Banner />
                <main className={ style.main }>
                    <Lottie 
                        autoplay={ true }
                        loop={ true }
                        animationData={ check_animation }
                        rendererSettings={{
                            preserveAspectRatio: "xMidYMid slice"
                        }}
                        height={ 300 }
                        width={ 300 }
                    />
                    <h3 className={ style.sectionHeader } style={{ textAlign: "center", marginTop: "-.5rem" }}>Iscrizione al piano premium cancellata</h3>
                    <div className={ style.orangeBtn } onClick={ () => props.setPage({ page: "home" }) }>
                        <img style={{ marginLeft: "1rem" }} alt="" src={ icons.home_icon } />
                        <h3>VAI ALLA HOME</h3>
                    </div>
                </main>
            </>;

        default:
            return <main className={ style.main }>
                
            </main>
    }
}

export default StripeHandler;
